import { createErrorMessage, serviceBase } from "../../../service";
import api from "../../../api";

const MeterUnitTariff = {
  ...serviceBase,
  getList(params = {}, onSuccess = () => {}, onError = () => {}) {
    params.filters = api.helpers.formFilters(params.filters);
    Object.keys(params).forEach(key => !params[key] && delete params[key]);
    let preList = this.getPreList("getList", params);
    return api
      .get(`${preList ? "/" + preList : ""}/${this.resource}`, {
        params
      })
      .then(res => {
        onSuccess({ list: res.data.items });
        return res;
      })
      .catch(res => {
        createErrorMessage(res);
        onError(res);
      });
  },
  preList: function(params) {
    return `projects/${params.project_id || "-"}/meter-units/${
      params.meter_unit_id
    }`;
  },
  preListOption: {
    getList: true,
    get: true,
    create: true,
    update: true,
    delete: true,
    deleteList: true
  },
  resource: "tariffs"
};
MeterUnitTariff.create = MeterUnitTariff.update;
export default MeterUnitTariff;
